import { List, Button } from "antd";
import { Icon } from "components/common";
import { localisedValue, useNavigate } from "utils";
import {
  BOOKINGS_LISTING_PATH,
  BOOKINGS_DETAIL_PATH,
  TASKS_LISTING_PATH,
  RMS_APPROVALS_LISTING_PATH,
  RMS_PAYMENTS_LISTING_PATH,
} from "constants/app-paths";
import { useSelector } from "react-redux";
import { getCurrentApp } from "core/appRegistry";
import { getTimeAgoSimple } from "utils/date";
import { t } from "i18next";

const getNotificationDetailPath = (type, action, id) => {
  const currentAppKey =
    useSelector((state) => state.app.currentApp) || getCurrentApp()?.key;
  let pathName;

  const idQuery = id ? `?q[id_eq]=${id}` : "";

  switch (type) {
    case "Approval":
      pathName = `/${currentAppKey}${RMS_APPROVALS_LISTING_PATH}${idQuery}`; 
      break;
    case "Task":
      pathName = TASKS_LISTING_PATH;
      break;
    case "Booking":
      pathName =
        action === "detail"
          ? BOOKINGS_DETAIL_PATH.replace(":bookingId", id)
          : BOOKINGS_LISTING_PATH;
      break;
    case "Payment":
      pathName = `/${currentAppKey}${RMS_PAYMENTS_LISTING_PATH}${idQuery}`;
      break;
    default:
      return null;
  }

  return pathName;
};

const NotificationTile = ({ item, onMarkAsRead }) => {
  const navigate = useNavigate();
  const { payload, source_type, source_id, created_at, is_read, id } = item;
  const { icon, booking_number, action } = payload?.data || {};
  const path = getNotificationDetailPath(source_type, action, source_id);

  const handleTileClick = () => {
    onMarkAsRead(item);
  };

  const handleViewModule = (e) => {
    e.stopPropagation();
    if (path) {
      navigate(path);
    }
  };

  return (
    <div
      style={is_read === false ? { background: "#dff1e0" } : {}}
      onClick={handleTileClick}
      className="pointer"
    >
      <List.Item>
        <List.Item.Meta
          avatar={
            <Icon
              icon={"AiFillNotification"}
              style={{
                fontSize: "20px",
                color: "#009F2B",
                alignItems: "center",
              }}
            />
          }
          title={localisedValue({ object: payload?.data, key: "message" })}
          description={
            <>
              {booking_number && (
                <div>
                  {booking_number}
                  {created_at && <span style={{ margin: "0 8px" }}></span>}
                </div>
              )}
              {path && (
                <div>
                  <Button
                    type="link"
                    onClick={handleViewModule}
                    style={{
                      color: "#009F2B",
                      padding: 0,
                      height: "auto",
                      fontWeight: 500,
                    }}
                  >
                    {`${t("View")} ${t(item?.source_type)}`}
                  </Button>
                </div>
              )}
            </>
          }
        />
        <div style={{ marginInlineStart: 8 }}>
          {getTimeAgoSimple(created_at)}
        </div>
      </List.Item>
    </div>
  );
};

export default NotificationTile;
